import { useFlag as useUnleashFlag } from "@unleash/nextjs/client";

// The flags is defined at https://project.scmp.tech/product/web/scmp-pwa-v2/-/feature_flags
type Flag = "enable_infinite_scroll" | "enable_paywall";

export const useFlag = (flag: Flag) => {
  const isEnabled = useUnleashFlag(flag);
  return isEnabled;
};
